'use client';

import React from 'react';
import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';

export function Loader(): React.JSX.Element {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
      <CircularProgress color="primary" size={38} />
    </Box>
  );
}

export default Loader;
